<template>
<div>
  <v-card class="card fill-height">
    <v-card-title>
      <span class="font-weight-light text-truncate">
        <span v-text="item.id"></span> 
        <h4>{{ item.name }}</h4>
      </span>
    </v-card-title>
    <v-divider></v-divider>
    <iframe width="560" height="315" :src="item.link" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </v-card>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  props: ['item'],
  data: () => ({
    html: '',
    doc: '',
  }),
  methods : {
    async navigate (url) {
      console.log(url)
      let x = await axios.get(url)
      console.log(x)
      this.doc = x.data
      this.sdialog = true
    }
  }
}
</script>
<style scoped>
.v-dialog > .v-card > .v-toolbar {
  position: sticky;
  top: 0;
  z-index: 999;
}
</style>